/* global $ */

// import { parseFragment } from 'parse5'
import { merge, curry } from 'ramda'

export const htmlTextReducer = (str, compact = true) => {
  const result = str
    .replace(/<span>/g, '')
    .replace(/<\/span>/g, '')
    .replace(/<div>/g, '')
    .replace(/<\/div>/g, '')
    .replace(/<p>/g, '')
    .replace(/<\/p>/g, '')
    .replace(/[\r\n]/g, '')
  return compact ? result.replace(/\s{2,}/g, ' ') : result
}

export default function cleanDOM(wraperElem) {
  // Open office loves adding spans all over the place with styles

  wraperElem.find('font, span, section').each(() => {
    $(this)
      .contents()
      .unwrap()
  })

  // Some paste adds meta elements, remove Ellipsis mark up
  wraperElem
    .find(
      'meta, xml, style, script, title, link, content-tools, content-comment, contenttools, div.handles, br, hr, o\\:p'
    )
    .remove()

  // get rid of divs that wrap paragraphs
  wraperElem
    .find('div')
    .has('>p')
    .each((i, elem) => {
      $(elem)
        .contents()
        .unwrap()
    })

  // remove html comments
  wraperElem.contents().each((i, node) => {
    if (node.nodeType === 8) {
      // Node.COMMENT_NODE
      $(node).remove()
    }
  })

  const validAttributes = ['href']
  // remove all the invalid attributes from the elements
  wraperElem.find('*').each((i, el) => {
    const attrs = el.attributes
    for (let i = attrs.length - 1; i >= 0; i--) {
      const name = attrs[i].name
      if (validAttributes.indexOf(name) === -1) {
        el.removeAttribute(name)
      }
    }
  })

  // And it seems to replace some spaces with a freaking return in Open Office!
  const txt = escape(wraperElem.html())
  if (txt.indexOf('%0A') > -1) {
    wraperElem.html(
      unescape(txt.replace(/(%0A)+/g, ' ').replace(/(%20)+/g, ' ')).trim()
    )
  }
}

export const cleanEmptyElementsFactory = curry(cleanEmptyElements)

function cleanEmptyElements(config, elem) {
  const defaultTextReplacer = ($elem) =>
    $elem.text((i, cnt = '') =>
      cnt.replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ')
    )

  // Set defaults wiht R.merge
  config = merge({
    textReplacer: defaultTextReplacer,
  })(config)

  // if it is an image or iframe, ignore
  if (elem.is('img, iframe')) {
    return
  }

  const children = elem.children()
  if (children.length) {
    children.each((ind, elem) => cleanEmptyElements(config, $(elem)))
  } else if (elem.text().length) {
    // sometimes jQuery is throwing errors with setting the text
    try {
      config.textReplacer(elem)
    } catch (e) {
      // eat the error
    }
  }

  // if the previous element is the same exact type, than combine it. AKA <b>f</b><b>oo</b> will become <b>foo</b>
  // Use DOM previousSibling. JQ prev() skip to the prev non-text node causing merge non-siblind elements
  const prev = elem[0].previousSibling
  const prevNodeName = prev && prev.nodeName
  if (
    prevNodeName === elem.prop('nodeName') &&
    ['B', 'I', 'U', 'EM'].indexOf(prevNodeName) > -1
  ) {
    prev.innerHTML = prev.innerHTML + elem.html()
    elem.remove()
  } else if (!elem.children().length && !elem.text().length) {
    // Using detatch so I can detect that the element was removed
    elem.data('deleted', true).detach()
  }
}
